/** @jsxImportSource @emotion/react */
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Checkbox } from '@mui/material';
import { ControlBtnGroup, SubTitleGroup, SubTitleLayout } from 'components/layouts/ContentLayout';

import CustomGrid from 'components/grids/CustomGrid';
import useSessionStore from 'stores/useSessionStore';
import { Code } from 'models/common/CommonCode';
import { getCommonCodeNames } from 'apis/admin/CommonCode';
import { MpItemTodoList, MpItemTrackingCondition } from 'models/mp/MpTracking';

import { st } from '../../components/inputs/CustomInput';
import { findMpItemTodoList } from '../../apis/mp/MpTracking';

/**
 * MP ITEM 진행 필요 목록 조회
 * @constructor
 */
const MpItemTodoListPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [code, setCode] = useState<any>();

  const [condition, setCondition] = useState<MpItemTrackingCondition>({
    mpClsfCd: '',
    todoUserId: useSessionStore.getState().userId || '',
    myTodoYn: 'Y',
  });

  const [rowData, setRowData] = useState<MpItemTodoList[]>([]);

  useEffect(() => {
    getCommonCodes();
    handleSearch(condition);
  }, []);

  const getCommonCodes = async () => {
    const mpClsfCd: Code[] = await getCommonCodeNames('MP_CLSF_CD'); // MP분류
    setCode({
      mpClsfCd: mpClsfCd,
    });
  };

  // item 번호/표준명/local명, mp분류, 설비군, remark, 개조/개선 item 보고서, 진척율, 법인(플랜트) ...
  const layoutDefinition = useMemo(() => {
    return [
      {
        header: 'ITEM',
        align: 'center',
        columns: [
          { binding: 'itemId', header: t('mp.label.번호', '번호') },
          {
            binding: 'itemNm',
            header: t('mp.label.명', '명'),
            width: 250,
            align: 'left',
          },
          {
            binding: 'itemLocalNm',
            header: t('mp.label.로컬명', '로컬명'),
            width: '*',
            align: 'left',
          },
        ],
      },
      { binding: 'mpClsfNm', header: t('mp.label.분류', '분류'), align: 'center' },
      {
        binding: 'mpItemTpNm',
        header: t('mp.label.진행단계', '진행단계'),
        align: 'center',
        minWidth: 150,
        // wordWrap: true,
      },
      { binding: 'itemStatNm', header: t('mp.label.상태', '상태'), align: 'center' },
      { binding: 'dataInsDtm', header: t('mp.label.상태변경일', '상태변경일'), align: 'center' },

      { binding: 'overDdn', header: t('mp.label.경과일', '경과일'), align: 'center' },
      { binding: 'reqMgrNm', header: t('mp.label.담당자', '담당자'), align: 'center' },
      { binding: 'chgCrgeUserNm', header: t('mp.label.변경담당자', '변경담당자'), align: 'center' },
      { binding: 'mcrcNms', header: t('mp.label.분과위원', '분과위원'), align: 'center' },
    ];
  }, []);

  const initialized = (grid) => {
    grid.rowHeaders.columns.clear();
  };

  const handleSearch = async (condition: MpItemTrackingCondition) => {
    setCondition(condition);
    const response = await findMpItemTodoList(condition);
    if (response) {
      const rowData = response;
      setRowData(rowData);
    }
  };

  return (
    <>
      {/*<SearchBox>*/}
      {/*  <SearchBoxRow>*/}
      {/*    <InputBox>*/}
      {/*      <SearchRows className="FourCol">*/}
      {/*        <SearchCols>*/}
      {/*          <label>*/}
      {/*            <span>{String(t('mp.label.분류', '분류'))}</span>*/}
      {/*          </label>*/}
      {/*          <ComboBox*/}
      {/*            placeholder={String(t('mp.msg.분류', '분류'))}*/}
      {/*            options={code?.mpClsfCd}*/}
      {/*            defaultValue={condition?.mpClsfCd}*/}
      {/*            // isError={errors?.mpClsfCd}*/}
      {/*            // msgError={String(t('mp.msg.분류를 선택해 주세요.', '분류를 선택해 주세요.'))}*/}
      {/*            onChange={(value) => {*/}
      {/*              setCondition({ ...condition, mpClsfCd: value as string });*/}
      {/*            }}*/}
      {/*          />*/}
      {/*        </SearchCols>*/}
      {/*      </SearchRows>*/}
      {/*    </InputBox>*/}
      {/*    <SearchButtonWrap>*/}
      {/*      /!*<Button*!/*/}
      {/*      /!*  css={IconButton.button}*!/*/}
      {/*      /!*  className="reload"*!/*/}
      {/*      /!*  // onClick={btnReload}*!/*/}
      {/*      /!*  disableRipple*!/*/}
      {/*      /!*></Button>*!/*/}
      {/*      <Button*/}
      {/*        css={IconButton.button}*/}
      {/*        className="find"*/}
      {/*        onClick={() => handleSearch(condition)}*/}
      {/*        disableRipple*/}
      {/*      >*/}
      {/*        {t('com.button.조회', '조회')}*/}
      {/*      </Button>*/}
      {/*    </SearchButtonWrap>*/}
      {/*  </SearchBoxRow>*/}
      {/*</SearchBox>*/}
      <SubTitleLayout>
        <SubTitleGroup>
          <h3>{t('mp.label.진행 필요 List', '진행 필요 List')}</h3>
          <span className="total">
            {t('com.label.총', '총')}
            <span>{rowData ? rowData.length : 0}</span>
            {t('com.label.건', '건')}
          </span>
        </SubTitleGroup>
        <ControlBtnGroup>
          <div style={{ display: 'inline-flex', width: '100px', paddingTop: '5px' }}>
            <label htmlFor="curVerYn_popup" style={{ paddingTop: '0px' }}>
              {t('com.label.My Todo', 'My Todo')}
            </label>
            <Checkbox
              id="curVerYn_popup"
              css={st.checkbox}
              className="custom"
              checked={condition?.myTodoYn === 'Y'}
              onChange={(e, checked) => {
                const param = { ...condition, myTodoYn: checked ? 'Y' : 'N' };
                // setCondition({ ...condition, myTodoYn: checked ? 'Y' : 'N' });
                // setCondition(param);
                handleSearch(param);
              }}
              onClick={(e) => {
                // handleSearch(condition);
                console.log(condition);
              }}
              disableRipple
            />
          </div>
          {/*<Button*/}
          {/*  css={IconButton.button}*/}
          {/*  className="Exceldown"*/}
          {/*  disableRipple*/}
          {/*  onClick={onExportXlsxClick}*/}
          {/*>*/}
          {/*  {t('com.button.다운로드', '다운로드')}*/}
          {/*</Button>*/}
        </ControlBtnGroup>
      </SubTitleLayout>
      <CustomGrid
        layoutDefinition={layoutDefinition}
        rowData={rowData}
        height={645}
        initialized={initialized}
        isReadOnly={true}
        isSelector={false}
        align="center"
      />
    </>
  );
};

export default MpItemTodoListPage;
